import { EhrName } from "@metriport/shared-internal";
import { PatientMapping } from "../../../api/ehr";
import EhrLinkSection from "../shared/PatientLinking";

type HealthieSectionProps = {
  patientMapping: PatientMapping | undefined;
  cxId: string;
};

export default function HealthieSection({ patientMapping, cxId }: HealthieSectionProps) {
  return <EhrLinkSection ehr={EhrName.Healthie} patientMapping={patientMapping} cxId={cxId} />;
}
